import { render, staticRenderFns } from "./link-feed.vue?vue&type=template&id=1dcc2378&scoped=true&"
import script from "./link-feed.vue?vue&type=script&lang=js&"
export * from "./link-feed.vue?vue&type=script&lang=js&"
import style0 from "./link-feed.vue?vue&type=style&index=0&id=1dcc2378&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcc2378",
  null
  
)

export default component.exports